import { TermsDataType } from '@/types/terms.type';

export const personalInfoCollectionData: TermsDataType[] = [
  {
    title: '개인정보 수집 및 이용 동의\n\n',
    title2: '1. 개인정보의 수집/이용 목적',
    discription2: [
      ['a.', '회원 관리'],
      ['b.', '서비스 제공에 관한 계약 이행 및 요금정산'],
      ['c.', '맞춤형 회원 서비스 제공'],
      ['d.', '사고 발생 시 원인 규명 및 처리를 위한 수집/이용'],
    ],
    lineBreak: true,
  },
  {
    title2: '2. 수집하는 개인정보의 항목',
    discription1:
      '① 수집하는 개인정보의 항목\n' +
      '회사가 수집하는 개인정보의 항목은 이용자가 서비스를 이용하기 위해 필수로 필요한 항목과 이용자의 선택에 따른 항목이 있습니다.',
    lineBreak: true,
  },
  {
    table: {
      title: '',
      headers: [
        { title: '구분' },
        { title: '수집항목' },
        { title: '보유 및 이용 기간' },
      ],
      rows: [
        {
          cells: [
            { value: '회원가입 및 관리' },
            {
              value:
                'ID,PW,이름,생년월일,성별,내국인여부,이메일 주소,통신사,휴대전화번호, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)',
            },
            {
              value:
                '회원자격 유지 시 까지\n' +
                '※ 단, 관계 법령에 따라 파기하지 않고 보존하여야 하는 경우에는 해당 기간까지',
              rowSpan: 7,
            },
          ],
        },
        {
          cells: [
            {
              value: '운전연수 서비스 이용을 위한 운전면허 정보 등록',
              rowSpan: 2,
            },
            {
              value:
                '[필수] 운전면허 정보: 면허종류, 면허주소, 적성검사 만료일, 발급일, 기타 운전면허증 기재 정보(주민등록번호 제외), 운전점수',
            },
          ],
        },
        {
          cells: [
            {
              value: '[필수] 고유식별정보: 운전면허 번호',
            },
          ],
        },
        {
          cells: [
            { value: '서비스 이용을 위한 결제카드정보 등록', rowSpan: 2 },
            {
              value:
                '[필수] 카드사, 카드종류, 카드번호, 유효기간, 생년월일, 암호화된 카드 식별정보(Key)',
            },
          ],
        },
        {
          cells: [
            {
              value:
                '※ 결제카드 정보는 할인혜택 등의 서비스 제공을 위해 카드 BIN번호 및 끝 네자리 번호만 보관하고, 전자결제 서비스 위탁업체에 전달 후 회신 받은 암호화된 카드 식별정보(Key)로 관리합니다.',
            },
          ],
        },
        {
          cells: [
            { value: '운전연수 서비스 이용을 위한 예약 및 이용 정보 등록' },
            {
              value:
                '[필수] 예약 및 이용 정보: 예약 내역, 결제내역, 위치정보 및 각종 문의사항, 운전점수',
            },
          ],
        },
        {
          cells: [
            { value: 'SNS 연동 및 가입' },
            {
              value:
                '[필수] SNS 연동정보(SNS 종류, SNS ID 식별 값), 이름, 출생연도, 생일, 성별, 이메일주소, 휴대폰번호, 암호화된 동일인 식별정보(CI)',
            },
          ],
        },
      ],
    },
  },
  {
    discription1:
      '또한 이용자의 서비스 이용 과정이나 업무 처리 과정에서 다음과 같은 정보들이 추가 수집 될 수 있습니다.',
    discription2: [
      [
        '-',
        '유선 또는 온라인 상담 서비스 이용 시 : 상담 내역(서비스 이용 내역, 유선/온라인 상담 녹취내용 등)',
      ],
      [
        '-',
        '서비스중 계좌 이체를 통한 결제/환불 이용 시 : 계좌정보(예금주,은행명,계좌번호)',
      ],
      [
        '-',
        '플랫폼 서비스 이용 시 : 접속 기기 및 환경 정보(IP Address, 쿠키, 방문일시, 기기정보 등)',
      ],
    ],
    lineBreak: true,
  },
  {
    discription1:
      '회사는 사고발생 시 사고원인 규명과 사고의 신속한 처리, 통계작성 및 과학적 연구 목적의 가명정보 처리 등을 위하여 자동차 내부에 부착된 영상정보 수집장치를 통하여 자동차의 주행영상(정차 중인 경우 포함)을 촬영하여 녹화할 수 있습니다.',
    lineBreak: true,
  },
  {
    discription1:
      '② 개인정보 수집방법\n' +
      '회사는 다음과 같은 방법으로 개인정보를 수집합니다.',
    discription2: [
      [
        '-',
        '플랫폼을 통한 회원 가입, 하위 부가 서비스 및 이벤트 신청 시 정보 수집',
      ],
      ['-', 'SNS 연동 및 가입을 통한 수집'],
      ['-', '본인확인 서비스를 통한 수집'],
      ['-', '유선 또는 온라인 상담 서비스 이용'],
      ['-', '이벤트 경품 응모, 배송 요청'],
      ['-', '제휴사로부터의 제공'],
      ['-', '생성정보 수집 툴을 통한 자동 수집'],
      ['-', '자동차 정보 수집장치를 통한 수집'],
      ['-', '서비스 이용 과정에서 자동으로 수집'],
      ['-', '본인/타인의 민원 또는 신고'],
    ],
    lineBreak: true,
  },
  {
    title2: '3. 개인정보의 보유 및 이용 기간',
    discription1:
      '회사는 이용자가 회원자격을 유지하고 있는 동안 수집된 이용자의 개인정보를 보유/이용할 수 있으며, 이용자가 탈퇴하거나 자격을 상실할 경우에는 이용자의 별도 요청이 없더라도 수집된 회원정보를 삭제 및 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존하며, 이용자의 처리정지, 삭제 요구권의 대상이 되지 아니합니다.\n\n' +
      '① 회사 내부 방침에 의한 정보 보유',
  },
  {
    table: {
      headers: [
        { title: '보유 근거' },
        { title: '보유 항목' },
        { title: '보유 기간' },
      ],
      rows: [
        {
          cells: [
            { value: '회원 탈퇴 후 재가입 방지 목적' },
            { value: '암호화된 동일인 식별정보(CI)' },
            { value: '3개월' },
          ],
        },
        {
          cells: [
            { value: '회원의 자격정지, 악의적 서비스 이용 재발 방지 목적' },
            {
              value:
                '암호화된 동일인 식별정보(CI), 면허번호, 악의적 서비스 이용내역 및 제재 사유, 일자',
            },
            { value: '10년' },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    discription1: '② 개인정보 수집방법',
  },
  {
    table: {
      headers: [
        { title: '보존 근거' },
        { title: '보존 항목' },
        { title: '보존 기간' },
      ],
      rows: [
        {
          cells: [
            { value: '전자상거래 등에서의 소비자보호에 관한 법률' },
            {
              value:
                '계약 또는 청약철회 등에 관한 기록(회원 식별정보, 계약/청약철회 기록 등)',
            },
            { value: '5년' },
          ],
        },
        {
          cells: [
            { value: '전자상거래 등에서의 소비자보호에 관한 법률' },
            { value: '대금결제 및 재화 등의 공급에 관한 기록' },
            { value: '5년' },
          ],
        },
        {
          cells: [
            { value: '소비자의 불만 및 분쟁처리에 관한 기록' },
            { value: '소비자의 불만 및 분쟁처리에 관한 기록' },
            { value: '3년' },
          ],
        },
        {
          cells: [
            { value: '신용정보의 이용 및 보호에 관한 법률' },
            { value: '신용정보의 수집/처리 및 이용 등에 관한 기록' },
            { value: '3년' },
          ],
        },
        {
          cells: [
            { value: '통신비밀보호법' },
            { value: '웹 사이트 방문기록(로그기록, IP 등)' },
            { value: '3개월' },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    discription1:
      '회원은 상기 개인정보 수집 및 이용 동의를 거부할 권리가 있습니다. 다만, 동의 거부 시 서비스 이용이 불가능할 수 있습니다. 상세 내용은 개인정보처리방침을 참고 바랍니다.',
    lineBreak: true,
  },
];
